import { Pipe, PipeTransform } from '@angular/core';
import { isNumeric } from '../util/helpers';

@Pipe({
  name: 'tagName'
})
export class TagNamePipe implements PipeTransform {

  transform(value: any, startIndex?: number): any {
    const tagName: string = value || '';
    if (tagName.length > 0) {
      const splitTags = tagName.split('::');
      if (isNumeric(startIndex) && startIndex > 0) {
        return splitTags.slice(startIndex, splitTags.length - 1).join(' ');
      } else {
        return splitTags[splitTags.length - 1];
      }
    }

  }
}
